module.exports = __webpack_public_path__ + "static/img/discount_num.af2aa35f.png";